import request from '@/utils/request';
const querystring = require('querystring')

//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comMonthFinance/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const fetchAllData = query => {
    var list = request({
        url: 'comMonthFinance/getList.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//启用-禁用
export const changeStatus = query => {
    var list = request({
        url: 'comMonthFinance/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'comMonthFinance/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete = query => {
    var list = request({
        url: 'comMonthFinance/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDeleteMore = query => {
    var list = request({
        url: 'comMonthFinance/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handUpdateMore = query => {
    var list = request({
        url: 'comMonthFinance/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const changeForm = query => {
    var list = request({
        url: 'comMonthFinance/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const changeActualForm = query => {
    var list = request({
        url: 'comMonthFinance/updateActual.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {
    var list = request({
        url: 'comMonthFinance/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const downFinanceExcel = query => {
    var list = request({
        url: 'comMonthFinance/downExcel.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};



